import { Injectable } from '@angular/core';
import { VisitStatusCode } from '@fs/enums/visit-state.enum';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { AuthService } from '@services/auth.service';
import { ApiEndPointType } from '@shared/enums/common';
import { HttpRepo } from '@shared/services/HttpRepo';

@Injectable({
  providedIn: 'root'
})
export class VisitService {

  constructor(private httpRepo:HttpRepo, private auth:AuthService) {
    this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(),ApiEndPointType.FS);
  }

  GetVisit(visitId: string) {
    return this.httpRepo.Get("serviceagreementvisits/" + visitId);
  }

  GetVisits(state:DataSourceRequestState, searchKey:string) {
    return this.httpRepo.Get("serviceagreementvisits", this.httpRepo.GetCommonURLQueryParams(state, searchKey));
  }

  GetJobSiteVisits(jobsiteId: string, state:DataSourceRequestState) {
    return this.httpRepo.Get("jobsites/"+jobsiteId+"/serviceagreementvisits", this.httpRepo.GetCommonURLQueryParams(state));
  }

  ChangeVisitStatus(visitId: string, status: VisitStatusCode) {
    return this.httpRepo.Patch("serviceagreementvisits/"+visitId, status);
  }

  PostponeVisit(visitId: string, data: any) {
    return this.httpRepo.Post("serviceagreementvisits/"+ visitId + "/postponement", data);
  }
}
